import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Fade-up reveal on scroll into view
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal for headlines. `lines` = array of strings.
// trigger="view" (default) animates when scrolled into view; "load" animates immediately.
export const KineticLines = ({ lines, className = "", lineClassName = "", start = 0.15, trigger = "view" }) => {
  const anim = { y: "0%" };
  const motionProps =
    trigger === "load"
      ? { animate: anim }
      : { whileInView: anim, viewport: { once: true } };
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            {...motionProps}
            transition={{ duration: 1, ease: EASE, delay: start + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

// Staggered container helpers
export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};

export const staggerItem = {
  hidden: { opacity: 0, y: 36 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } },
};
